import clone from 'lodash/cloneDeep';
import initialState from '../../store/initialState';
import {
  ACTIVATE_CATEGORY_STARTING,
  ACTIVATE_CATEGORY_SUCCESS,
  ACTIVATE_CATEGORY_ERROR,
} from '../../constants/actionTypes';

export default function activateCategoryReducer(state = initialState.activateCategory, action) {
  switch (action.type) {
    case ACTIVATE_CATEGORY_STARTING: {
      const {categoryId} = action;
      const newState = clone(state);

      if (!newState[categoryId]) {
        newState[categoryId] = clone(initialState.activateCategory.categoryId);
      }

      const categoryData = newState[categoryId];
      categoryData.saving = true;
      categoryData.saved = false;
      categoryData.error = null;

      return newState;
    }

    case ACTIVATE_CATEGORY_SUCCESS: {
      const {categoryId} = action;
      const newState = clone(state);

      if (!newState[categoryId]) {
        newState[categoryId] = clone(initialState.activateCategory.categoryId);
      }

      const categoryData = newState[categoryId];
      categoryData.saving = false;
      categoryData.saved = true;
      categoryData.error = null;
      return newState;
    }

    case ACTIVATE_CATEGORY_ERROR: {
      const {categoryId} = action;
      const newState = clone(state);

      if (!newState[categoryId]) {
        newState[categoryId] = clone(initialState.activateCategory.categoryId);
      }

      const categoryData = newState[categoryId];
      categoryData.saving = false;
      categoryData.saved = false;
      categoryData.error = action.err;
      return newState;
    }

    default: {
      return state;
    }
  }
}
